import { createFileRoute } from '@tanstack/react-router';
import { ContainerTypeLegacy, ExportTelemetryForm } from '@amber-ui/core';

function ExportTelemetryRoute() {
  const { bin } = Route.useSearch();

  if (!bin) return null;

  return <ExportTelemetryForm container_id={bin} container_type={ContainerTypeLegacy.bin} />;
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/export_telemetry')({
  component: ExportTelemetryRoute,
});
